export const STATUS_KEYS = {
    base: 'statuses',
    all: ['statuses'],
    list: ['statuses', 'list'],
} as const;
